import axios from 'axios'

export default class Simple {
	/**
	 * @constructor
	 * @param {Object} init
	 * @param {string} url
	 * @property {number} id
	 * @property {string} name
	 */
	constructor (init = {}, url = '') {
		this.id = null
		this.setDefaultData()

		if (typeof init === 'number') {
			this.id = init
			this.baseURL = url
			this.getSingle().then()
		} else {
			this.setDefaultData(init)
		}
	}
	setDefaultData (init = {}) {
		if (!init) return

		this.id = init.hasOwnProperty('id') && !isNaN(Number(init.id)) ? Number(init.id) : 0
		this.name = init.hasOwnProperty('name') ? init.name.toString() : ''
	}
	static getAll (params, baseURL) {
		console.log(params)
		return axios.get(baseURL, {params})
			.then(res => {
				return {
					...res.data,
					data: this.createObjectFromArray(res.data.data)
				}
			})
			.catch(err => {
				console.error(err)
				return null
			})
	}
	/**
	 * return new object from resolve request
	 * @property Array
	 * @returns [Simple]
	 */
	static createObjectFromArray (arr) {
		return arr.map(item => new Simple(item))
	}
	/**
	 * get event by id
	 * @returns {Promise<void>}
	 */
	async getSingle () {
		try {
			const {data} = await axios.get(`${this.baseURL}${this.id}`)
			this.setDefaultData(data.data)
		} catch (e) {
			console.error(e)
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/SimpleName/Simple.class.js